export const TEST_ID = 'droneActivityLink';
